<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <label> Usuário</label>
    </div>
    <tab-navegacao />
    <v-container fluid
      ><v-row align="center">
        <v-col>
          <v-btn
            v-if="isAllowed(1)"
            color="info"
            to="/usuario/criar"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>
        </v-col>
        <v-col class="text-right">
          <v-checkbox
            v-if="usuarios.length > 0"
            v-model="showAtivo"
            label="MOSTRAR ITENS INATIVOS"
          ></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn
            @click="baixarlista()"
            v-if="usuarios.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        class="elevation-1"
        :loading="loading"
        loading-text="Buscando dados..."
        :search="search"
        :options.sync="options"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        <template v-slot:item.ativo="{ item }">
          {{ item.ativo ? "Ativo" : "Inativo" }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span v-if="isAllowed(1)">Editar</span>
            <span v-else>Ver</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import TabNavegacao from "../../Tabs/TabCadastroUsuario";
import { downloadLista } from "../../../services/usuarioService";
import { getUserRoles } from "@/services/loginService";

export default {
  name: "listausuarios",
  data() {
    return {
      loading: false,
      showAtivo: false,
      search: "",
      headers: [
        {
          text: "Id",
          align: "start",
          value: "id",
        },
        { text: "Matricula", value: "matricula" },
        { text: "Nome", value: "nome" },
        { text: "Perfil", value: "perfil" },
        { text: "Cargo", value: "cargo" },
        { text: "Status", value: "ativo" },
        { text: "", value: "actions", sortable: false },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
    };
  },
  computed: {
    ...mapState("usuario", ["usuarios"]),
    ...mapState("departamento", ["departamentos"]),
    ...mapState("cargo", ["cargos"]),
    ...mapState("perfil", ["perfis"]),
    ...mapState("local", ["locais"]),
    ...mapState("permissao", ["permissoes"]),
    ...mapActions("permissao", ["atualizarPermissoes"]),
    filteredList() {
      if (this.showAtivo === false) {
        return this.usuarios.filter((usu) => {
          return (
            ((usu.nome || "").toLowerCase().includes(this.search.toLowerCase()) ||
              (usu.departamento || "")
                .toLowerCase()
                .includes(this.search.toLowerCase()) ||
                (usu.perfil || "").toLowerCase().includes(this.search.toLowerCase()) ||
              (usu.cargo || "").toLowerCase().includes(this.search.toLowerCase())) &&
            usu.ativo === true
          );
        });
      } else {
        return this.usuarios.filter((usu) => {
          return (
            (usu.nome || "").toLowerCase().includes(this.search.toLowerCase()) ||
            (usu.departamento || "")
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            (usu.perfil || "").toLowerCase().includes(this.search.toLowerCase()) ||
            (usu.cargo || "").toLowerCase().includes(this.search.toLowerCase())
          );
        });
      }
    },
  },
  methods: {
    ...mapActions("usuario", ["atualizarUsuarios", "atualizarUsuario"]),
    ...mapActions("departamento", ["atualizarDepartamentos"]),
    ...mapActions("cargo", ["atualizarCargos"]),
    ...mapActions("perfil", ["atualizarPerfis"]),
    ...mapActions("local", ["atualizarLocais"]),
    ver(usuario) {
      this.atualizarUsuario(usuario);
      this.$router.push(`/usuario/ver`);
    },
    editar(usuario) {
      this.atualizarUsuario(usuario);
      if (this.isAllowed(1)) {
        this.$router.push({
          path: "/usuario/editar",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      } else {
        this.$router.push({
          path: "/usuario/ver",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      }
    },
    onChangePage(pageOfItems) {
      // update page of items
      this.pageOfItems = pageOfItems;
    },
    baixarlista() {
      downloadLista();
    },
    sort: function (s) {
      //if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      } else this.currentSortDir = "asc";
      this.currentSort = s;
      this.loadBreweries();
    },
    async doAjax() {
      /*setTimeout(() => {
        this.isLoading = false;
      }, 5000);*/

      if (!this.departamentos || this.departamentos.length == 0) {
        this.atualizarDepartamentos();
      }
      if (!this.cargos || this.cargos.length == 0) {
        this.atualizarCargos();
      }
      if (!this.perfis || this.perfis.length == 0) {
        this.atualizarPerfis();
      }
      if (!this.locais || this.locais.length == 0) {
        this.atualizarLocais();
      }
      if (!this.permissoes || this.permissoes.length == 0) {
        this.atualizarPermissoes();
      }
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarUsuarios();
      this.loading = false;
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
  },
  watch: {
    "options.page"(p) {
      this.$router.replace({
        query: { ...this.$route.query, page: String(p) },
      });
    },
    "$route.query.page": {
      immediate: true,
      handler(val) {
        const qPage = parseInt(val, 10);
        const next = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
        if (next !== this.options.page) {
          this.options = { ...this.options, page: next };
        }
      },
    },
  },
  created: function () {
    this.doAjax();
    this.obterLista();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }

    const qPage = parseInt(this.$route.query.page, 10);
    this.options.page = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
  },
  components: {
    TabNavegacao,
  },
};
</script>